import axios from 'axios';

const state = {
    webConfig: {
        stripePublicKey: "",
        appVersion: ""
    },
    appConfig: {
        permissions: [],
        groupFrequencyOptions: [],
        accountSettings: {}
    }
}

const getters = {
    getPermissions: state => state.appConfig.permissions,
    getStripePK: state => state.webConfig.stripePublicKey,
    getGroupFrequencyOptions: state => state.appConfig.groupFrequencyOptions,
    getPrices: state => includeTrial => {
        if(includeTrial){
            return state.webConfig.prices
        } else {
            return state.webConfig.prices.filter(price => price.id !== 'trial')
        }
    },
    getAppVersion: state => {
        return state.webConfig.appVersion
    },
    getAccountSettings: state => state.appConfig.accountSettings
}

const actions = {
    async loadWebConfig({commit}) {
        const response = await axios.get('/web/config')
        commit('setWebConfig', response.data)
    },
    async loadAppConfig({ commit }) {
        const response = await axios.get('/api/config')
        commit('setAppConfig', response.data)
    }
}

const mutations = {
    setWebConfig(state, webConfig) {
        state.webConfig = webConfig
    },
    setAppConfig(state, appConfig) {
        state.appConfig = appConfig
    },
    // For use by account store when compliance settings are updated.
    setAccountSettings(state, accountSettings){
      state.appConfig.accountSettings = accountSettings
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


